var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnapshot6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88332 12.5406C8.88332 13.6884 9.33108 14.7892 10.1281 15.6009C10.9251 16.4125 12.0061 16.8685 13.1333 16.8685C14.2605 16.8685 15.3415 16.4125 16.1385 15.6009C16.9355 14.7892 17.3833 13.6884 17.3833 12.5406C17.3833 11.3928 16.9355 10.292 16.1385 9.48033C15.3415 8.66869 14.2605 8.21272 13.1333 8.21272C12.0061 8.21272 10.9251 8.66869 10.1281 9.48033C9.33108 10.292 8.88332 11.3928 8.88332 12.5406Z",
    stroke: "#AA1A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1474 20.7016L15.1365 26.8226C14.6052 27.3631 13.885 27.6667 13.134 27.6667C12.3831 27.6667 11.6628 27.3631 11.1316 26.8226L5.11924 20.7016C3.53431 19.0875 2.45497 17.0311 2.01772 14.7923C1.58047 12.5536 1.80494 10.2331 2.66275 8.12433C3.52056 6.01552 4.97318 4.21309 6.83692 2.94497C8.70067 1.67685 10.8918 1 13.1333 1C15.3748 1 17.566 1.67685 19.4297 2.94497C21.2935 4.21309 22.7461 6.01552 23.6039 8.12433C24.4617 10.2331 24.6862 12.5536 24.2489 14.7923C23.8117 17.0311 22.7323 19.0875 21.1474 20.7016Z",
    stroke: "#AA1A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapshot6);
export default __webpack_public_path__ + "static/media/snapshot6.6a1c4a708e915c8bc08cd86f2a5dcaf9.svg";
export { ForwardRef as ReactComponent };